module.exports = __webpack_public_path__ + "img/著作权证.afb2c04a.png";